import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowUpRightFromSquare} from "@fortawesome/free-solid-svg-icons";
import logoOtowaNikkan from "../images/logo_otowa_nikkan.webp";
import img80th from "../images/80th_img.webp";
import thunderImg from "../images/thunder2026.webp";

export const FirstView = () => {
  return (
    <section id="firstView">
      <div className="subTitleWrap">
        <img src={img80th} alt="80thロゴ" />
        <h2 className="subTitle">
          音羽電機工業　
          <br />
          創業80周年記念
        </h2>
      </div>
      <h2>
        雷災害から
        <br className="responsiveBr" />
        大切な資産を守る
        <br />
        ～外部雷保護・
        <br className="responsiveBr" />
        内部雷保護とリスク管理～
      </h2>
      <img src={logoOtowaNikkan} alt="音羽 日刊工ロゴ" loading="lazy" className="logoOtowaNikkan" />
      <div className="prologue">
        <p>
          企業における「資産」とは、もはや「情報資産」といっても過言ではありません。情報資産は、バックアップを取っていても落雷などで設備が故障すれば「永遠に失われる」可能性もあり、クラウドサービスを展開する現在の社会において、その懸念はむしろ増大しています。OTOWAグループでは、「企業資産（＝情報資産）を守ることが私たちの使命」と位置づけ、リスクとなる「雷」という切り口から「雷害対策の必要性」をご紹介いたします。
        </p>
      </div>

      <a className="lightningPhotoContest" href="https://www.otowadenki.co.jp/contest_category/num21/" target="_blank">
        ［背景画像］拡大
        <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
        <br />
        音羽電機工業株式会社「第21回雷写真コンテスト」
        <br />
        佳作作品
        <br />
        （音羽電機工業株式会社のウェブサイトにリンクします）
      </a>
      <img src={thunderImg} alt="夜の斜張橋に雷が落ちる様子" loading="lazy" className="mainVisual" />
    </section>
  );
};
